import { Grid, Paper, Stack, Typography } from "@mui/material";

import StatCard from "../components/StatCard";
import useDrivers from "../services/useDrivers";
import useRides from "../services/useRides";

export default function DashboardPage() {
  const { drivers } = useDrivers();
  const { rides } = useRides();

  const onlineDrivers = drivers.filter((driver) => driver.is_online).length;
  const activeRides = rides.filter((ride) => ride.status !== "trip_completed" && ride.status !== "cancelled").length;

  return (
    <Stack spacing={3}>
      <Typography variant="h4" fontWeight={700}>
        Dashboard
      </Typography>

      <Grid container spacing={3}>
        <Grid item xs={12} md={4}>
          <StatCard label="Total Drivers" value={drivers.length} />
        </Grid>
        <Grid item xs={12} md={4}>
          <StatCard label="Online Drivers" value={onlineDrivers} />
        </Grid>
        <Grid item xs={12} md={4}>
          <StatCard label="Active Rides" value={activeRides} />
        </Grid>
      </Grid>

      <Paper sx={{ p: 3, borderRadius: 3 }}>
        <Typography variant="h6" fontWeight={700}>
          MVP Notes
        </Typography>
        <Typography color="text.secondary" sx={{ mt: 1 }}>
          The admin panel uses a mock token for now, but the data tables already point at the Flask API so
          you can replace auth with real role-based login later without changing the page structure.
        </Typography>
      </Paper>
    </Stack>
  );
}
